import React from "react";
import { Column, ColumnId } from ".";
import base from "./base";
import StatusCellContent from "../components/StatusCellContent";

function status({ width, onResize, language }: Column.Options) {
	return base(
		ColumnId.Status,
		(item) => <StatusCellContent item={item} language={language} />,
		{
			width,

			onResize: onResize as (
				columnWidth?: number | undefined,
				dataKey?: string | undefined,
			) => void,
		},
	);
}

export default status;
